<!-- Markup outline for Secondary Nav -->
<section id="secondary-nav-top-bar-wrapper">
    <div class="topbar-top">
        <div id="bx-topbar-mobile-toggle" class="mobile-toggle">
            <a class="sidebar-mobile-toggler btn" (click)="toggleMainMenu()">
                <i class="icon-ic-menu"></i>
            </a>
        </div>

        <nav class="nav-list-container">
            <ul>
                <li *ngIf="estimate.ID_Customer">
                    <a
                        [title]="estimate.Name ? estimate.Name : ''"
                        (click)="
                            !estimate.Name.startsWith('Unassigned') &&
                                permissionService.isAvailable('customers.maintain-customers.view-customers') &&
                                featureService.isStateAvailable('customers') &&
                                changeTopbarRoute($event, ['/customers', 'list', estimate.ID_Customer])
                        "
                        class="secondary-nav-icon secondary-nav-icon-client truncated-hoverable-120"
                        [ngClass]="{ disabled: estimate.Name.startsWith('Unassigned') }"
                        ><span>{{ estimate.Name }}</span></a
                    >
                </li>
                <li *ngIf="leadsEnabled && !readonly">
                    <a
                        [title]="lead ? lead.leadNumber : ('leads.unassigned' | translate)"
                        (click)="
                            permissionService.isAvailable('estimates.maintain-leads.view-leads') &&
                                featureService.isStateAvailable('leads') &&
                                lead &&
                                changeTopbarRoute($event, ['/leads', 'list', estimate.ID_Lead])
                        "
                        class="secondary-nav-icon secondary-nav-icon-lead truncated-hoverable-120"
                        [ngClass]="{ disabled: !estimate.ID_Lead }">
                        <span>{{ lead ? lead.leadNumber : ('leads.unassigned' | translate) }}</span>
                    </a>
                </li>
                <li *ngIf="estimate">
                    <ng-container *ngIf="estimate.IsTemplate; then templateDesktop; else estimateLinkDesktop"></ng-container>
                    <ng-template #templateDesktop>
                        <div class="new template-dropdown">
                            <ng-select
                                class="dark auto-grow"
                                [items]="templateList"
                                bindLabel="description"
                                bindValue="iD_Estimate"
                                [clearable]="false"
                                [searchable]="true"
                                (change)="templateChange()"
                                [(ngModel)]="selectedTemplateId"
                                id="template-list-dropdown">
                                <ng-template ng-label-tmp let-item="item">
                                    <span class="ng-value-label"><i class="icon-ic-estimates-s1"></i>{{ item.description }}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item">
                                    <div class="option-template-list" title="{{ item.description }}">
                                        <span> {{ item.description }} </span>
                                    </div>
                                </ng-template>
                            </ng-select>
                            <button class="btn-bx-secondary-stroked ml-2" type="button" (click)="useTemplate()">Use Template</button>
                        </div>
                    </ng-template>
                    <ng-template #estimateLinkDesktop>
                        <a
                            [title]="estimate.FullDescription"
                            class="secondary-nav-icon secondary-nav-icon-quote truncated-hoverable-120 disabled active"
                            ><span *ngIf="estimate.IsSampleData">SAMPLE -</span> <span>{{ estimate.FullDescription }}</span></a
                        >
                    </ng-template>
                </li>
                <li *ngIf="estimate.ID_Job">
                    <a
                        [title]="estimate.Job?.FullDescription"
                        class="secondary-nav-icon secondary-nav-icon-job truncated-hoverable-120"
                        (click)="
                            permissionService.isAvailable('jobs.maintain-jobs.view-jobs') &&
                                featureService.isStateAvailable('jobs') &&
                                changeTopbarRoute($event, ['/jobs', 'list', estimate.ID_Job, 'details'])
                        ">
                        <span>{{ estimate.Job?.FullDescription }}</span></a
                    >
                </li>
            </ul>

            <div class="estimate-accepted-dd" *ngIf="permissionService.isAvailable('estimates.maintain-estimates.set-estimate-status')">
                <ng-container *ngIf="readonly; then readonlyStatusTablet; else blockStatusTablet"></ng-container>
                <ng-template #readonlyStatusTablet>
                    <span>{{ estimate.Status }}</span>
                </ng-template>
                <ng-template #blockStatusTablet>
                    <ng-select
                        class="dark slim"
                        [items]="estimateStatusList"
                        [clearable]="false"
                        [searchable]="false"
                        (change)="setStatus($event)"
                        [(ngModel)]="estimate.Status"
                        [disabled]="isDisabled">
                    </ng-select>
                </ng-template>
            </div>
        </nav>

        <div class="hero-status">
            <div class="hero-status-dropdowns" *ngIf="permissionService.isAvailable('estimates.maintain-estimates.set-estimate-status')">
                <ng-container *ngIf="readonly; then readonlyStatusDesktop; else blockStatusDesktop"></ng-container>
                <ng-template #readonlyStatusDesktop>
                    <span>{{ estimate.Status }}</span>
                </ng-template>
                <ng-template #blockStatusDesktop>
                    <ng-select
                        class="dark slim"
                        [items]="estimateStatusList"
                        [clearable]="false"
                        [searchable]="false"
                        (change)="setStatus($event)"
                        [(ngModel)]="estimate.Status"
                        [disabled]="isDisabled">
                    </ng-select>
                </ng-template>
            </div>
            <div class="hero-status-figures">
                <div class="status-figure" *ngIf="estimate.IsAccepted" [ngClass]="{ accepted: estimate.IsAccepted }">
                    <title>Accepted</title>
                    <span>{{ estimate.AcceptedDate | date }}</span>
                    <footer></footer>
                </div>
                <div class="status-figure" [ngClass]="{ accepted: estimate.IsAccepted }">
                    <title>Quote Total</title>
                    <span *ngIf="!readonly; else readonlyTotalRange">{{ estimate.TotalIncMarkupTax | bxCurrency }}</span>
                    <ng-template #readonlyTotalRange>
                        <span>{{ estimate.TotalIncMarkupTaxRange }}</span>
                    </ng-template>
                    <footer></footer>
                </div>
            </div>
        </div>
    </div>

    <div class="topbar-menu">
        <menubar-estimates
            *ngIf="estimate"
            [estimate]="estimate"
            (itemClick)="onChangeRoute($event, 'estimates')"
            [active]="activeGroup === 'estimates'"
            [readonly]="readonly">
        </menubar-estimates>

        <menubar-jobs
            *ngIf="estimate && !readonly && !isDisabled"
            [estimate]="estimate"
            [job]="estimate.Job"
            (itemClick)="onChangeRoute($event, 'jobs')"
            [active]="activeGroup === 'jobs'">
        </menubar-jobs>
    </div>

    <span *ngIf="!layoutService.isMobile(); else mobileView">
        <button
            class="btn-menu-scroll btn-menu-scroll--left"
            (click)="doLeft()"
            (mouseover)="moveLeft()"
            (mouseout)="clearMove()"
            [ngClass]="{ disabled: activeGroup === 'estimates' || atLeftEnd }">
            <i [ngClass]="{ 'icon-ic-sec-nav-left-none-s1': atLeftEnd, 'icon-ic-sec-nav-left-more-s1': !atLeftEnd }"></i>
        </button>
        <button
            class="btn-menu-scroll btn-menu-scroll--right"
            (click)="doRight()"
            (mouseover)="moveRight()"
            (mouseout)="clearMove()"
            [ngClass]="{ disabled: activeGroup !== 'estimates' && atRightEnd }">
            <i [ngClass]="{ 'icon-ic-sec-nav-right-none-s1': atRightEnd, 'icon-ic-sec-nav-right-more-s1': !atRightEnd }"></i>
        </button>
    </span>

    <ng-template #mobileView>
        <button class="btn-menu-scroll btn-menu-scroll--left" (click)="doLeftMobile()" [ngClass]="{ disabled: atLeftEnd }">
            <i [ngClass]="{ 'icon-ic-sec-nav-left-none-s1': atLeftEnd, 'icon-ic-sec-nav-left-more-s1': !atLeftEnd }"></i>
        </button>
        <button class="btn-menu-scroll btn-menu-scroll--right" (click)="doRightEstimates()" [ngClass]="{ disabled: atRightEnd }">
            <i [ngClass]="{ 'icon-ic-sec-nav-right-none-s1': atRightEnd, 'icon-ic-sec-nav-right-more-s1': !atRightEnd }"></i>
        </button>
    </ng-template>
</section>
